import {Env} from '../../env';

const api = {
  get: (sessionId: string) => `${Env.Endpoint}/${sessionId}/search/extras`,
};

export const ExtraApi = api;
